module.exports = __webpack_public_path__ + "img/ic_loop_on.aa7ad574.svg";